import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 24px;
  background: linear-gradient(135deg, ${(props) => props.theme.$bg_green}, #ffffff 55%);
  border: 1px solid ${(props) => props.theme.$secondary_green_light};
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(33, 53, 74, 0.06);
  padding: 24px;

  .clarify-head {
    display: flex;
    align-items: flex-start;
    gap: 12px;

    .clarify-icon {
      width: 38px;
      height: 38px;
      border-radius: 10px;
      background: ${(props) => props.theme.$bg_green};
      border: 1px solid ${(props) => props.theme.$secondary_green_light};
      color: ${(props) => props.theme.$primary_green};
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;

      i {
        font-size: 21px;
      }
    }

    .clarify-title {
      margin: 0;
      font-size: 1rem;
      font-weight: 500;
      color: ${(props) => props.theme.$gray900};
    }

    .clarify-reason {
      margin: 2px 0 0;
      font-size: 0.88rem;
      color: ${(props) => props.theme.$gray600};
    }
  }

  .clarify-hints {
    margin-top: 16px;

    .hints-label {
      font-size: 0.72rem;
      font-weight: 700;
      letter-spacing: 0.08em;
      text-transform: uppercase;
      color: ${(props) => props.theme.$gray500};
      margin-bottom: 6px;
    }

    ul {
      margin: 0;
      padding: 0;

      li {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        font-size: 0.88rem;
        color: ${(props) => props.theme.$gray700};
        margin-bottom: 4px;

        &::before {
          content: '';
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background: ${(props) => props.theme.$primary_green};
          flex-shrink: 0;
          margin-top: 8px;
        }
      }
    }
  }

  textarea.form-control {
    margin-top: 14px;
    resize: vertical;

    &:focus {
      border-color: ${(props) => props.theme.$primary_green};
      box-shadow: 0 0 0 0.2rem rgba(0, 159, 121, 0.15);
    }
  }

  .clarify-help {
    margin: 6px 0 0;
    font-size: 0.78rem;
    color: ${(props) => props.theme.$gray500};
  }

  .clarify-actions {
    margin-top: 18px;
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
  }
`;
